import React from "react";
import { Box, Button } from "@mui/material";
import { ArrowRight } from "lucide-react";
import { FormattedMessage } from "react-intl";

const LoginOrSignin = ({ onSectionClicked }) => {
  return (
    <Box>
      <Box sx={{ mb: "24px" }}>
        <Box
          component="p"
          sx={{
            textAlign: "center",
            px: "16px",
            m: 0,
            fontSize: "0.875rem",
            fontFamily: "Segoe UI Regular, system-ui, sans-serif",
            color: "hsl(220, 10%, 46%)",
          }}
        >
          <FormattedMessage id="sub_please_sign" />
        </Box>
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "8px",
        }}
      >
        <Box sx={{ width: "100%", maxWidth: "250px" }}>
          <Button
            fullWidth
            type="button"
            onClick={() => onSectionClicked("login")}
            sx={{
              bgcolor: "hsl(153 68% 25%)",
              color: "white",
              fontFamily: "Segoe UI Semibold, system-ui, sans-serif",
              fontWeight: 700,
              fontSize: "0.875rem",
              px: "1.5rem",
              py: "0.75rem",
              borderRadius: "0.75rem",
              textTransform: "none",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "0.5rem",
              "&:hover": {
                bgcolor: "hsl(153 68% 25% / 0.9)",
              },
            }}
          >
            <FormattedMessage id="signin" />
            <ArrowRight size={14} />
          </Button>
        </Box>
        <Box sx={{ width: "100%", maxWidth: "250px" }}>
          <Button
            fullWidth
            type="button"
            onClick={() => onSectionClicked("sign_up")}
            sx={{
              bgcolor: "transparent",
              color: "hsl(220, 25%, 12%)",
              border: "1px solid hsl(220, 13%, 91%)",
              fontFamily: "Segoe UI Semibold, system-ui, sans-serif",
              fontWeight: 700,
              fontSize: "0.875rem",
              px: "1.5rem",
              py: "0.75rem",
              borderRadius: "0.75rem",
              textTransform: "none",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "0.5rem",
              "&:hover": {
                bgcolor: "hsla(220, 13%, 91%, 0.3)",
              },
            }}
          >
            <FormattedMessage id="not_account" />
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default LoginOrSignin;
